import {
	DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
	DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI,
} from '../../entities';
import { NounSubtypeKey, TypeFilterValueKey } from '../../filters/universal-type';
import { get3PLogo } from '../../icons';
import { type ThirdPartyConfig } from '../../schemas/3p-config';

import { ZendeskIcon } from './icon';
import { ZendeskSearchResultIcon } from './search-result-icon';

export const zendeskConfig: ThirdPartyConfig = {
	displayName: 'Zendesk',
	id: 'zendesk',
	icon: get3PLogo(ZendeskIcon, 'Zendesk', 'medium'),
	resourceType: 'zendesk-connector',
	searchResultIcon: get3PLogo(ZendeskSearchResultIcon, 'Zendesk', 'large'),
	integrationAri: 'ari:cloud:platform::integration/zendesk',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.WorkItem,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI,
				subTypes3P: [],
			},
		],
		[
			TypeFilterValueKey.Document,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
				subTypes3P: [NounSubtypeKey.Document],
			},
		],
	]),
	filters: ['lastUpdated', 'onlyTitleMatch'],
	requiresOauth: true,
	isEnabled: () => true,
};
